var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"disclaimer",class:[_vm.className],attrs:{"to":"/list/disclaimer/main","hover-class":"none"}},[_c('span',{staticClass:"tx"},[_vm._v(_vm._s(_vm.title))]),_c('fc-icon',{attrs:{"type":"32_risk"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }